import React, { Component } from 'react';
import { switcherratemonth } from '../helpers/Lists.js';

interface IProps {
    label?: any;
    selectedswitcherratemonth?: string;
    classes?: string;
    onChange(v: any): void;
    onBlur?(): void;
}

export class SwitcherRateMonthSelect extends Component<IProps, any> {
    render() {
        return (
            <div className='grid justify-c'>
                {this.props.label &&
                <label htmlFor='switcherratemonth'>{this.props.label}</label>
                }
                <select name="switcherratemonth" id="switcherratemonth" aria-required="true" aria-invalid="false" 
                    className={this.props.classes ?? ''}
                    onChange={this.props.onChange}
                    onBlur={() => {if (this.props.onBlur) this.props.onBlur();}}>
                    <option key={'currentlendertopup-select'}  value="" selected={!this.props.selectedswitcherratemonth} className="placeholder">Select Month</option>
                    {switcherratemonth.map((l) => {
                        return <option key={'currentlendertopup-'+l.value} value={l.value} selected={l.value === this.props.selectedswitcherratemonth}>{l.name}</option>
                    })
                    }
                </select>
            </div>
        );
    }
}